export default defineNuxtRouteMiddleware(() => {
  const aside = useAside()
  aside.close()
})
